export function shortenAddress(addr) {
  const a = String(addr || '');
  if (a.length <= 12) return a;
  return `${a.slice(0, 6)}…${a.slice(-4)}`;
}

export function formatUsd(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return '$0.00';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function formatCryptoAmount(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('en-US', { maximumFractionDigits: 6 });
}

export function getIsPhoneSession(user) {
  if (user?.authType === 'phone') return true;
  if (user?.sessionAuthType === 'phone') return true;
  return false;
}
